import { auth } from "./hu/auth";
import { common } from "./hu/common";
import { customers } from "./hu/customers";
import { dashboard } from "./hu/dashboard";
import { deals } from "./hu/deals";
import { nav } from "./hu/nav";
import { organizations } from "./hu/organizations";
import { products } from "./hu/products";
import { profile } from "./hu/profile";
import { quotations } from "./hu/quotations";
import { orders } from "./hu/orders";
import { deliveryNotes } from "./hu/deliveryNotes";
import { reports } from "./hu/reports";
import { systemAdmin } from "./hu/systemAdmin";
import { status } from "./hu/status";
import { debug } from "./hu/debug";
import { contracts } from "./hu/contracts";
import { shared } from "./hu/shared";
import { templates } from "./hu/templates";
import { documents } from "./hu/documents";
import { settings } from "./hu/settings";
import { warehouse } from "./hu/warehouse";
import { inventory } from "./hu/inventory";
import { sales } from "./hu/sales";
import { worksheets } from "./hu/worksheets";
import { tasks } from "./hu/tasks";
import projects from "./hu/projects";
import { notifications } from "./hu/notifications";
import { formBuilder, myForms, formRenderer, formFiller, formSubmissions } from "./hu/formBuilder";
import { listBuilder } from "./hu/formBuilder";
import { notes } from "./hu/notes";
import { customerPortal } from "./hu/customerPortal";
import { customerSignup } from "./hu/customerSignup";
import { customerAccess } from "./hu/customerAccess";
import { leads } from "./hu/leads";
import { timeTracking } from "./hu/timeTracking";
import projectReports from './hu/projectReports';
import onboarding from './hu/onboarding';
import mfa from './hu/mfa';
import { saas } from './hu/saas';
import { documentStorage } from './hu/documentStorage';

export default {
  auth,
  common,
  nav,
  dashboard,
  customers,
  products,
  quotations,
  orders,
  deliveryNotes,
  deals,
  reports,
  organizations,
  systemAdmin,
  profile,
  status,
  contracts,
  shared,
  debug,
  templates,
  documents,
  settings,
  warehouse,
  inventory,
  sales,
  worksheets,
  tasks,
  projects,
  notifications,
  formBuilder,
  listBuilder,
  myForms,
  formRenderer,
  formFiller,
  formSubmissions,
  notes,
  customerPortal,
  customerSignup,
  customerAccess,
  leads,
  timeTracking,
  projectReports,
  onboarding,
  mfa,
  saas,
  documentStorage
};